export enum Actions {
    NotSelectable = 0,
    AcceptableFullyConfident = 1,
    AcceptableNotFullyConfident = 2,
    NotAcceptable = 3,
    Evaluate = 4
}